import { render, staticRenderFns } from "./ComplianceCategoryGrid.vue?vue&type=template&id=333dd855&scoped=true"
import script from "./ComplianceCategoryGrid.vue?vue&type=script&lang=js"
export * from "./ComplianceCategoryGrid.vue?vue&type=script&lang=js"
import style0 from "./ComplianceCategoryGrid.vue?vue&type=style&index=0&id=333dd855&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333dd855",
  null
  
)

export default component.exports